import { Component, inject, input } from '@angular/core';
import { Router } from '@angular/router';
import {RdsDividerModule, RdsIconsModule} from '@rds/angular-components';
import { SafeHtmlPipe } from '../../../pipes/safe-html.pipe';

@Component({
  selector: 'inexp-knowledge-successtories',
  imports: [RdsIconsModule, SafeHtmlPipe, RdsDividerModule],
  templateUrl: './knowledge-success-stories.component.html',
  styleUrl: './knowledge-success-stories.component.scss',
})
export class KnowledgeSuccessStoriesComponent {
  _uid = input<string>();
  component = input<string>();
  knowledgeSection = input<string>();
  router = inject(Router);
  successStories = input<any[]>();
  hasPublishedItems(): boolean {
    return this.successStories()?.some(b => b.published === true) ?? false;
  }
}
